module.exports = __webpack_public_path__ + "static/media/light-theme-stopped.01b95540.svg";